import React from 'react';
import {Table, Row, Col, Button, Tooltip, Input, Select} from 'antd';
import './TrashDetail.css';
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {
  getTrashItems,
  clearAllTrash,
  restoreAssets,
  deleteAssets,
  moveAssets,
  downloadAssets,
  getTrashUsageList
} from "../../../actions/TrashAction";
import { convertDateString} from "../../../utils/sorters";
// dateSorter
import TrashAssets from "./TrashAssets";
import {sendNotification, TRASH_PAGE_SIZE} from "../../../utils";
import fileextension from 'file-extension'
import { getImageAssettByExtension } from '../../../utils'
import '../../../components/collection/MiddleViewStyles.css'
import RestoreModal from "./RestoreModal";
import DownloadModal from "./DownloadModal";
import MultiMoveModal from "../../../components/multi-selector-header-options/MultiMoveModal";
import MultiDeleteModal from "../../../components/multi-selector-header-options/MultiDeleteModal";
import Popup from "./Popup";
import TrashMultiSelectorHeader from "./TrashMultiSelectorHeader";
import genericFile from "../../../assets/images/generic-file.png";
import FolderImg from "../../../assets/images/folder-img.png";
import MultiDownloadModal from '../../multi-selector-header-options/MultiDownloadModal';

const ButtonGroup = Button.Group;

class TrashDetail extends React.Component {
  constructor(props){
    super(props);
    this.componentRef = React.createRef();
    this.tableRef = React.createRef();
    // Debounce del buscador: evita una request por cada tecla.
    this.temporizadorBusqueda = null;
    this.state  = {
      selectedRowKeys: [],
      keyCollection: "TrashCollection",
      // Filtros y paginacion. El listado se resuelve en el servidor, asi que
      // estos valores viajan en la request y no se filtra nada en el navegador.
      terminoBusqueda: "",
      filtroTipo: "",
      pagina: 1,
      indice: null,
      showMoveModal: false,
      showMultiDeleteModal: false,
      showRestoreModal: false,
      showDownloadModal: false,
      showMultiDownloadModal: false,
      showModalMultiMove: false,
      folderId: "",
      isCommandPressed: false,
      isClickedOutside: false,
      visibleOptions: false,
      popup: {
        visible: false,
        x: 0,
        y: 73
      }
    };

    const {intl} = props;

    this.columns = [
      {
        title: intl.formatMessage({id: "trash-col-name"}),
        key: "nombres",
        dataIndex: "name",
        // sorter: (a, b) => {
        //   a = a.name || '';
        //   b = b.name || '';
        //   return a.localeCompare(b);
        // },
        width: '25%',
        render: (value, row) => {
          return (
              <div >
                {value}
              </div>
          )
        }
      },
      {
        title: intl.formatMessage({id: "trash-col-asset"}),
        key: "asset",
        dataIndex: "asset",
        width: "10%",
        render: (value, row) => { 
          return row.type === 'image' && fileextension(row.originalURL) !== 'svg' ? (
            <img
              key={row._id}
              src={this.handleSetSrc(row)}
              alt={row.name}
              style = {{
                maxWidth: "100%"
              }}
            />) : row.type === 'folder' ? <div
            key={row._id}
            style = {{
              paddingLeft: "20%"
            }}
          >
            <img
              src={FolderImg}
              alt={row.name}
              style = {{
                width: "50px",
                height: "50px",
              }}
            />
          </div> : (
              <div
                style = {{
                  paddingLeft: "20%"
                }}
                key={row._id}
              >
                <img
                  src={genericFile}
                  alt={row.name}
                  style = {{
                    width: "50px",
                    height: "50px",
                  }}
                />
              </div> 
            )
        }
      },
      {
        title: intl.formatMessage({id: "trash-col-type"}),
        key: "tipo",
        dataIndex: "type",
        // sorter: (a, b) => {
        //   a = a.type || '';
        //   b = b.type || '';
        //   return a.localeCompare(b);
        // },
      },
      {
        title: intl.formatMessage({id: "trash-col-location"}),
        key: "ubicación",
        width: "20%",
        dataIndex: "route",
        // sorter: (a, b) => {
        //   a = a.route || '';
        //   b = b.route || '';
        //   return a.localeCompare(b);
        // },
      },
      {
        title: intl.formatMessage({id: "trash-col-size"}),
        key: "peso",
        dataIndex: "fileSize",
        render: (value, row) => {
          return (
            <div key={row._id} style={{textAlign: 'center'}}>{row.fileSize ? this.formatBytes(row.fileSize) : "0 Bytes"}</div>
          )
        }
        // sorter: (a, b) => parseInt(a.fileSize) - parseInt(b.fileSize),
      },
      {
        title: intl.formatMessage({id: "trash-col-delete"}),
        key: "deleting",
        dataIndex: "deleting",
        // sorter: dateSorter,
        render: (value, row) => {
          return (
            <div key={row._id}>{`${convertDateString(row.goTrashDate)}`}</div>
          )
        }
      },
      {
        title: intl.formatMessage({id: "trash-col-actions"}),
        key: "acciones",
        dataIndex: "actions",
        render: (value, row) => {
          const {intl} = this.props;
          return (
          <Row key={row._id}>
            <ButtonGroup>
              
              <Tooltip title={intl.formatMessage({id: "trash-option-delete-asset"})} >
                <Button
                    type="default"
                    onClick={this.handleShowMultiDeleteModal}
                  >
                    <img src="/images/icons/delete-asset-icon.svg" alt="delete icon" />
                </Button>
              </Tooltip>
              <Tooltip title={intl.formatMessage({id: "trash-option-restore-asset"})} >
                <Button
                    type="default"
                    onClick={(e) => this.onRestoreAssets(e, row._id)}
                  >
                    <img src="/images/icons/restore-asset-icon.svg" alt="restore icon" />
                </Button>
              </Tooltip>
              <Tooltip title={intl.formatMessage({id: "trash-option-move-asset"})} >
                <Button
                    type="default"
                    onClick={this.handleShowModalMultiMove}
                  >
                    <img src="/images/icons/move-asset-icon.svg" alt="move icon" />
                </Button>
              </Tooltip>
              <Tooltip title={intl.formatMessage({id: "trash-option-download-asset"})} >
                <Button
                    type="default"
                    onClick={this.handleShowMultiDownloadModal}
                  >
                    <img src="/images/icons/download-asset-icon.svg" alt="download icon" />
                </Button>
              </Tooltip>
            </ButtonGroup>
          </Row>
        )}
      },
    ];
    this.addModalUserRef = React.createRef()
  }

  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  handleShowModalMultiMove = () => {
    this.setState({
      showModalMultiMove: true,
      visibleOptions: false,
    });
  }

  handleChangeVisibleOptions = (value) => {
    this.setState({
      visibleOptions: value,
    });
  }

  handleHiddenModalMultiMove = () => {
    this.setState({
      showModalMultiMove: false,
    });
  }

  handleHiddenMoveModal = () =>{
    this.setState({
      showMoveModal: false
    })
  }
  handleShowMoveModal = () => {
    this.setState({
      showMoveModal: true
    })
  }
  handleHiddenMultiDownloadModal = () =>{
    this.setState({
      showMultiDownloadModal: false
    })
  }
  handleShowMultiDownloadModal = () => {
    this.setState({
      showMultiDownloadModal: true
    })
  }
  handleShowMultiDeleteModal = () => {
    this.setState({
      showMultiDeleteModal: true
    })
  }
  handleHiddenMultiDeleteModal = () =>{
    this.setState({
      showMultiDeleteModal: false
    })
  }
  handleHiddenRestoreModal = () =>{
    this.setState({
      showRestoreModal: false
    })
  }
  handleShowRestoreModal = () => {
    this.setState({
      showRestoreModal: true
    })
  }
  handleHiddenDownloadModal = () =>{
    this.setState({
      showDownloadModal: false
    })
  }
  handleShowDownloadModal = () => {
    this.setState({
      showDownloadModal: true
    })
  }

  handleSetSrc = r => {
    const { originalURL, lowQualityURL } = r;
    const itemUrl = !lowQualityURL ? originalURL :  (originalURL !== lowQualityURL) ? lowQualityURL : getImageAssettByExtension(r.originalURL);
    return itemUrl;
  }

  updateAssetsList(){
    const { workclient, intl, getTrashItems, getTrashUsageList } = this.props;
    const { terminoBusqueda, filtroTipo, pagina } = this.state;
    getTrashItems(workclient, {
      search: terminoBusqueda,
      type: filtroTipo,
      page: pagina,
      limit: TRASH_PAGE_SIZE,
    })
    getTrashUsageList(workclient, intl)
    this.setState({
      selectedRowKeys: []
    })
  }

  // Al cambiar un filtro siempre se vuelve a la pagina 1: quedarse en la pagina
  // 7 de un resultado que ahora tiene 2 paginas mostraria una tabla vacia.
  aplicarFiltros = (cambios) => {
    this.setState({ ...cambios, pagina: 1 }, () => this.updateAssetsList());
  }

  handleBuscar = (evento) => {
    const valor = evento.target.value;
    this.setState({ terminoBusqueda: valor });
    if (this.temporizadorBusqueda) clearTimeout(this.temporizadorBusqueda);
    this.temporizadorBusqueda = setTimeout(() => {
      this.aplicarFiltros({ terminoBusqueda: valor });
    }, 400);
  }

  handleFiltroTipo = (valor) => {
    this.aplicarFiltros({ filtroTipo: valor === "all" ? "" : valor });
  }

  handleCambioPagina = (pagina) => {
    this.setState({ pagina, selectedRowKeys: [] }, () => this.updateAssetsList());
  }

  onMoveAssets = () => {
    if(!this.validateAssetsEmpty()) return;
    const {workclient, intl} = this.props;
    const {folderId, selectedRowKeys} = this.state;
    if(folderId.length === 0){
      sendNotification('error', intl, intl.formatMessage({id: "trash-error-select"}));
      return;
    }
    this.props.moveAssets(workclient, selectedRowKeys, folderId)
  }

  componentDidUpdate(prevProps) {
    const {
      trash: oldTrash
    } = prevProps;

    const {
      loadingClearAllTrash: loadingClearAllTrashPrev,
      loadingRestoreAssets: loadingRestoreAssetsPrev,
      loadingDeleteAssets: loadingDeleteAssetsPrev,
      loadingMoveAssets: loadingMoveAssetsPrev,
      loadingDownloadAssets: loadingDownloadAssetsPrev,
    } = oldTrash;
    
    const {
      trash,
      intl
    } = this.props;

    const {
      loadingClearAllTrash,
      errorClearAllTrash,
      loadingRestoreAssets,
      errorRestoreAssets,
      loadingDeleteAssets,
      errorDeleteAssets,
      loadingMoveAssets,
      errorMoveAssets,
      loadingDownloadAssets,
      errorDownloadAssets,
    } = trash;
    //Casos de éxito
    if(loadingClearAllTrashPrev && !loadingClearAllTrash && !errorClearAllTrash){
      sendNotification('success', intl, intl.formatMessage({id: "trash-success-clear"}));
      this.updateAssetsList()
      return;
    }
    if(loadingRestoreAssetsPrev && !loadingRestoreAssets && !errorRestoreAssets){
      sendNotification('success', intl, intl.formatMessage({id: "trash-success-restore"}));
      this.updateAssetsList()
      return;
    }
    if(loadingDeleteAssetsPrev && !loadingDeleteAssets && !errorDeleteAssets){
      this.handleHiddenMultiDeleteModal();
      sendNotification('success', intl, intl.formatMessage({id: "trash-success-delete"}))
      this.updateAssetsList();
      return;
    }
    if(loadingMoveAssetsPrev && !loadingMoveAssets && !errorMoveAssets){
      this.handleHiddenModalMultiMove();
      sendNotification('success', intl, intl.formatMessage({id: "trash-success-move"}));
      this.updateAssetsList()
      return;
    }
    if(loadingDownloadAssetsPrev && !loadingDownloadAssets && !errorDownloadAssets){
      sendNotification('success', intl, intl.formatMessage({id: "trash-success-download"}));
      this.updateAssetsList()
      return;
    }
    //Casos de error
    if(loadingClearAllTrashPrev && !loadingClearAllTrash && errorClearAllTrash){
      sendNotification('error', intl, intl.formatMessage({id: "trash-error-clear"}));
      return;
    }
    if(loadingRestoreAssetsPrev && !loadingRestoreAssets && errorRestoreAssets){
      sendNotification('error', intl, intl.formatMessage({id: "trash-error-restore"}));
      return;
    }
    if(loadingDeleteAssetsPrev && !loadingDeleteAssets && errorDeleteAssets){
      this.handleHiddenMultiDeleteModal();
      sendNotification('error', intl, intl.formatMessage({id: "trash-error-delete"}));
      return;
    }
    if(loadingMoveAssetsPrev && !loadingMoveAssets && errorMoveAssets){
      this.handleHiddenModalMultiMove();
      sendNotification('error', intl, intl.formatMessage({id: "trash-error-move"}));
      return;
    }
    if(loadingDownloadAssetsPrev && !loadingDownloadAssets && errorDownloadAssets){
      sendNotification('error', intl, intl.formatMessage({id: "trash-error-download"}));
      return;
    }
  }

  onSelectedRowKeysChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  validateAssetsEmpty = () => {
    const {selectedRowKeys} = this.state;
    const {intl } = this.props
    if(selectedRowKeys.length === 0){
      sendNotification('error', intl, intl.formatMessage({id: "trash-error-select"}));
      return false;
    }
    return true
  }

  onClearAllAssets = () => {
    const { workclient, trash, intl } = this.props
    const {trashItems} = trash;
    if(trashItems.length === 0){
      sendNotification('error', intl, intl.formatMessage({id: "trash-error-no-assets"}));
      return;
    }
    const ids = trashItems.map(e => e._id)
    this.props.clearAllTrash(workclient, ids);
  }
  onDeleteAssets = () => {
    if(!this.validateAssetsEmpty()) return;
    const { workclient } = this.props
    const {selectedRowKeys} = this.state;
    this.props.deleteAssets(workclient, selectedRowKeys);
  }
  onRestoreAssets = (e, value) => {
    if(e){
      e.stopPropagation();
    }
    if(value){
      this.setState({
        selectedRowKeys: [value]
      });
      const { workclient } = this.props
      this.props.restoreAssets(workclient, [value]);
      return;
    }
    if(!this.validateAssetsEmpty()) return;
    const {selectedRowKeys} = this.state;
    const { workclient } = this.props
    this.props.restoreAssets(workclient, selectedRowKeys);
  }
  onDownloadAssets = () => {
    if(!this.validateAssetsEmpty()) return;
    const { workclient, trash, intl } = this.props;
    const {selectedRowKeys} = this.state;

    const itemsToDownload = trash.trashItems.filter(e => selectedRowKeys.includes(e._id));

    this.props.downloadAssets(workclient, itemsToDownload, intl);
  }

  // El peso total lo entrega el servidor (getBinSummary). Ya no se puede sumar
  // en el navegador: el listado viene paginado y solo llega la pagina actual.
  folderSpaceInBytes = () => {
    const {trash} = this.props;
    return trash.totalTrashSize || 0;
  }

  handleRowClick = (record, notRemove) => {
    const {selectedRowKeys, isCommandPressed} = this.state;
    if(selectedRowKeys.includes(record._id)){
      if(!isCommandPressed){
        const newRows = [record._id];
        this.setState({
          selectedRowKeys: newRows
        });
        return;
      }
      if(isCommandPressed){
        if(notRemove) return;
        const newRows = selectedRowKeys.filter(e => e !== record._id);
        this.setState({
          selectedRowKeys: newRows
        })
      }
    }else{
      if(selectedRowKeys.length === 0){
        selectedRowKeys.push(record._id)
        this.setState({
          selectedRowKeys: selectedRowKeys
        });
        return;
      }
      if(!isCommandPressed){
        const newRows = [record._id];
        this.setState({
          selectedRowKeys: newRows
        });
        return;
      }
      if(isCommandPressed){
        selectedRowKeys.push(record._id)
        this.setState({
          selectedRowKeys: selectedRowKeys
        });
        return;
      }
    }
  };

  componentDidMount() {
    document.addEventListener('click', this.handleOutsideClick);
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('keyup', this.handleKeyUp);
    this.updateAssetsList()
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('keyup', this.handleKeyUp);
    // Sin esto, un debounce pendiente dispara setState sobre un componente ya
    // desmontado si se sale de la papelera justo despues de escribir.
    if (this.temporizadorBusqueda) clearTimeout(this.temporizadorBusqueda);
  }

  handleOutsideClick = (event) => {
    if (
      this.componentRef.current &&
      !this.componentRef.current.contains(event.target)
    ) {
      if(this.state.visibleOptions) return;
      if(this.state.showModalMultiMove) return;
      if(this.state.showMultiDeleteModal) return;
      if(this.state.showMultiDownloadModal) return;

      const {selectedRowKeys} = this.state;
      if (selectedRowKeys && selectedRowKeys.length > 0) {
        this.setState({ 
          isClickedOutside: true,
          selectedRowKeys: []
        });
      }
      
    }
  };

  handleKeyDown = (event) => {
    if (event.key === 'Meta' || event.key === 'Control') { // 'Meta' is the key value for the "Command" key
      this.setState({ isCommandPressed: true });
    }
  };

  handleKeyUp = (event) => {
    if (event.key === 'Meta' || event.key === 'Control') {
      this.setState({ isCommandPressed: false });
    }
  };
  
  onRow = record => ({
    onContextMenu: event => {
      event.preventDefault();
      if (!this.state.visible) {
        const that = this
        document.addEventListener(`click`, function onClickOutside() {
          that.setState({popup: {visible: false}})
          document.removeEventListener(`click`, onClickOutside)
        })
      }
      this.handleRowClick(record, true);
      const ids = this.props.trash.trashItems.map(e => e._id)
      const index = ids.indexOf(record._id);
      const tableRect = event.currentTarget.getBoundingClientRect(); // Get the table's bounding rectangle
      const relativeX = event.clientX - tableRect.left; // Calculate relative X position
      const relativeY = event.clientY - tableRect.top; // Calculate relative Y position

      this.setState({
        popup: {
          record,
          visible: true,
          x: relativeX,
          y: relativeY + 73 + index * 100
        }
      })
    },
    onClick: event => {
      this.handleRowClick(record, false);
    }
  })

  handleFileRoute = parents => {
    const { breadcrumb } = this.props
    let route = '/'
    if (parents && parents.length !== 0) { 
      parents.forEach(itemParents => {
        breadcrumb.forEach(breadElement => {
          if (itemParents === breadElement._id)
          route = route +  breadElement.name + '/';
        })
      })
      return route
    } else return '/' 
    
  }

  render() {
    const { 
      selectedRowKeys, 
      showMultiDeleteModal,
      showRestoreModal,
      showDownloadModal,
      showModalMultiMove,
      keyCollection,
      popup,
      visibleOptions,
      showMultiDownloadModal,
      terminoBusqueda,
      filtroTipo,
      pagina
    } = this.state;

    const {workclient, contractedSpace, trash, intl, user} = this.props;

    const {
      loadingTrashItems,
      loadingMoveAssets,
      loadingDeleteAssets,
      loadingDownloadAssets,
      loadingRestoreAssets,
      trashItems,
      totalTrashItems,
    } = trash;

    const dataToLoad = trashItems.map(e => ({
      ...e,
      route: this.handleFileRoute(e.parents),
      children: [],
      id: e._id,
      key: e._id
    }));

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectedRowKeysChange,
    };

    const isAdminOrSuperadmin = (user.role === 'admin' || user.clientRole === 'admin');

    const itemsToDownload = trashItems.filter(e => selectedRowKeys.includes(e._id));
    return (
      <div className="container">
        <Row>
          <Col span={24}>
            <h4 className="title-dashboard">
              <b className="color-title-dashboard"><strong>{intl.formatMessage({ id: 'trash-title' })}</strong></b>
            </h4>
          </Col>
        </Row>
        <TrashAssets
          workclient={workclient}
          contractedSpace={contractedSpace}
          handleShowAddModalUser={()=>{}}
          onDelete = {this.onClearAllAssets}
          folderSpaceInBytes = {this.folderSpaceInBytes()}
          isAdminOrSuperadmin = {isAdminOrSuperadmin}
        />
        <div
          className="separation"
        />
        <div
          ref={this.componentRef}
        >
          <TrashMultiSelectorHeader
            selectedFiles = {selectedRowKeys}
            isAdminOrSuperadmin = {isAdminOrSuperadmin}
            onCancel = {()=>{
              this.setState({
                selectedRowKeys: []
              })
            }}
            onSelectAll = {()=>{
              const selected = trashItems.map(e => (e._id));
              this.setState({
                selectedRowKeys: selected
              })
            }}
            onDelete = {this.handleShowMultiDeleteModal}
            onRestore = {this.onRestoreAssets}
            onMove = {this.handleShowModalMultiMove}
            onDownload = {this.handleShowMultiDownloadModal}
            visibleOptions = {visibleOptions}
            handleChangeVisibleOptions = {this.handleChangeVisibleOptions}
          />
          <div
            className="separation"
          />
          <Row gutter={16} style={{ marginBottom: 16 }}>
            <Col xs={24} sm={14} md={10} style={{ marginBottom: 8 }}>
              <Input.Search
                allowClear
                value={terminoBusqueda}
                onChange={this.handleBuscar}
                onSearch={(valor) => this.aplicarFiltros({ terminoBusqueda: valor })}
                placeholder={intl.formatMessage({ id: 'trash-search-placeholder' })}
              />
            </Col>
            <Col xs={24} sm={10} md={6} style={{ marginBottom: 8 }}>
              <Select
                style={{ width: '100%' }}
                value={filtroTipo || 'all'}
                onChange={this.handleFiltroTipo}
              >
                <Select.Option value="all">{intl.formatMessage({ id: 'all' })}</Select.Option>
                <Select.Option value="folder">{intl.formatMessage({ id: 'folders' })}</Select.Option>
                <Select.Option value="image">{intl.formatMessage({ id: 'images' })}</Select.Option>
                <Select.Option value="video">{intl.formatMessage({ id: 'videos' })}</Select.Option>
                <Select.Option value="document">{intl.formatMessage({ id: 'documents' })}</Select.Option>
                <Select.Option value="audio">{intl.formatMessage({ id: 'files-audios' })}</Select.Option>
                <Select.Option value="other">{intl.formatMessage({ id: 'files-others' })}</Select.Option>
              </Select>
            </Col>
          </Row>
          <div className="table-responsive" style = {{
            position: "relative"
          }}>
            <Table
              ref = {this.tableRef}
              rowSelection={rowSelection}
              columns={this.columns}
              dataSource={dataToLoad}
              bordered
              className={'table-header-color'}
              pagination={{
                current: pagina,
                pageSize: TRASH_PAGE_SIZE,
                total: totalTrashItems || 0,
                showSizeChanger: false,
                onChange: this.handleCambioPagina,
              }}
              onRow={this.onRow}
              loading={loadingTrashItems}
              expandIconColumnIndex={-1}
            />
            <Popup 
              isAdminOrSuperadmin={isAdminOrSuperadmin}
              visible={popup.visible}
              x = {popup.x}
              y = {popup.y}
              onDelete={this.handleShowMultiDeleteModal}
              onRestore={this.onRestoreAssets}
              onMove={this.handleShowModalMultiMove}
              onDownload={this.handleShowMultiDownloadModal}
              intl={intl}
            />
          </div>
        </div>
        <MultiDeleteModal
          showModal={showMultiDeleteModal}
          handleHiddenModal={this.handleHiddenMultiDeleteModal}
          isFetching={loadingDeleteAssets}
          handleMultiDelete = {this.onDeleteAssets}
          items={selectedRowKeys}
          isTrash={true}
        />
        <MultiDownloadModal
          showModal={showMultiDownloadModal}
          handleHiddenModal={this.handleHiddenMultiDownloadModal}
          isFetching={loadingDeleteAssets}
          handleMultiDownload = {this.onDownloadAssets}
          items={itemsToDownload}
        />
        <RestoreModal
          showRestoreModal={showRestoreModal || loadingRestoreAssets}
          handleHiddenRestoreModal={this.handleHiddenRestoreModal}
          loading={loadingRestoreAssets}
          onAccept={()=>{
            this.onRestoreAssets()
          }}
        />
        <DownloadModal
          showDownloadModal={showDownloadModal}
          handleHiddenDownloadModal={this.handleHiddenDownloadModal}
          loading={loadingDownloadAssets}
          onAccept={()=>{
            this.onDownloadAssets()
          }}
        />
        <MultiMoveModal
          showModal={showModalMultiMove}
          handleHiddenModal={this.handleHiddenModalMultiMove}
          keyCollection={keyCollection}
          isMoving={loadingMoveAssets}
          handleMultiMove = {this.onMoveAssets}
          handleFolderSelect = {(folderId) => {
            this.setState({
              folderId: folderId
            })
          }}
          items={selectedRowKeys}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    contractedSpace: state.client && state.client.data ? state.client.data.contractedSpace : null,
    workclient: state.client.workclient,
    planServices: state.planServices.data,
    trash: state.trash,
    user: state.authUser.user,
    breadcrumb: state.client.breadcrumb,
  }
}

const mapDispatchToProps = {
  getTrashItems,
  clearAllTrash,
  restoreAssets,
  deleteAssets,
  moveAssets,
  downloadAssets,
  getTrashUsageList
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(TrashDetail)))
